import { ReactNode, useRef } from 'react';

export const useLastOpenChildren = (
  isOpen: boolean,
  children: ReactNode,
  hasExited: boolean
): ReactNode => {
  const lastOpenChildren = useRef<ReactNode>(null);

  if (isOpen) {
    lastOpenChildren.current = children;
  } else if (hasExited) {
    lastOpenChildren.current = null;
  }

  return isOpen ? children : lastOpenChildren.current;
};
